<h2 mat-dialog-title>Chart Upload Conflict</h2>
<mat-dialog-content>
	<p>
		While a chart you submitted was being uploaded, someone one else uploaded a chart for patient {{ data.patientId }}.
		Please choose which version to keep.
	</p>
	<div class="conflict-comparison">
		<div class="conflict-option" [class.selected]="selected === 'keep-local'" (click)="selectLocal()">
			<h3>Your Version</h3>
			<div class="conflict-image-container">
				<img [src]="data.localImage" alt="Your chart" />
			</div>
			<p class="conflict-label">Pending upload</p>
		</div>
		<div class="conflict-option" [class.selected]="selected === 'keep-remote'" (click)="selectRemote()">
			<h3>Server Version</h3>
			<div class="conflict-image-container">
				<img [src]="data.remoteImage" alt="Server chart" />
			</div>
			<p class="conflict-label">Uploaded {{ data.remoteLastModified | date:'short' }}</p>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-raised-button color="primary" [disabled]="!selected" (click)="confirm()">
		Keep Selected
	</button>
</mat-dialog-actions>
